import useMount from '@src/utils/hooks/use-mount';

import { observable, computed } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import DateUtil from '@src/utils/date-util';
import cmsApi from '@src/services/cms-api';
import Service from './service';
import aos from '@src/utils/aos';

import NaviBarStore from '@src/business-components/navibar/store';
class NewsDetailStore extends BaseStore {
  @observable isLoading = true;
  @observable title = '';
  @observable createTimestamp = '';
  @observable content = '';
  navibarStore = new NaviBarStore({ mainStore: this });
  @observable article_top_img = '';
  @computed
  get createDate() {
    if (!this.createTimestamp) {
      return '';
    }
    return DateUtil.formatDate(new Date(this.createTimestamp * 1000), 'yyyy/MM/dd hh:mm:ss');
  }

  getArticleRequestAsync = params => {
    const { catId, articleId } = params;
    return cmsApi.getArticleDetail({ categoryId: catId, articleId: articleId, api: '//www.xishanju.com/api.php' });
  };
  goto(text) {
    if (text === '首页' ) {
      const currentUrl = new URL(window.location.href);
      currentUrl.hash = '';
      // sessionStorage.setItem('from', JSON.stringify(['首页', '列表页']));
      let newUrlString = currentUrl.toString().replace('article.html', 'index.html');
      window.location.href = newUrlString;
    } else if (text === '招募列表' || text === '招募项目') {
      const currentUrl = new URL(window.location.href);
      currentUrl.hash = '';
      // sessionStorage.setItem('from', JSON.stringify(['首页', '列表页']));
      let newUrlString = currentUrl.toString().replace('article.html', 'list.html');
      window.location.href = newUrlString;
    }
  }

  use() {
    super.use();
    // this.getArticleRequest = useRequest(async params => await this.getArticleRequestAsync(params), { manual: true, throwOnError: true });

    useMount(async () => {
      window.scrollTo({
        top: 1,
        behavior: 'instant'
      });
      aos.reInit();
      // this.init();
      let { contentId } = this.$routeMatch.query;
      // console.log(contentId, 'contentId');
      Service.getLayersData(contentId).then(res => {
        console.log(res.data, 'this.getArticleRequest');
        this.title = res.data.content.item_title;
        this.createTimestamp = res.data.content.creatTime;
        this.content = res.data.content.content;
      });
    });
  }
}

export default NewsDetailStore;
